import { Component, h, Host, Listen, Prop, State } from '@stencil/core';
import { AccordionNode } from './utils';
import { ComponentView } from '../../../types/types';

@Component({
  tag: 'rtr-accordion',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RtrAccordion {
  @Prop() nodes!: AccordionNode[];
  @Prop() view: ComponentView = ComponentView.Default;

  @Prop({ mutable: true }) startingIndex: number = 0;

  @Listen('clickForOpenIndex', { capture: true, target: 'body' })
  setActiveIndex(e) {
    this.openedIndex = e.detail;
  }

  @State() openedIndex: number;

  componentWillLoad() {
    this.openedIndex = this.startingIndex;
  }

  handleOpenIndex = index => {
    if (this.openedIndex === index) {
      this.openedIndex = -1;
    } else {
      this.openedIndex = index;
    }
  };

  render() {
    return (
      <Host
        class={{
          RAContainer: true, //
          RADefault: this.view === ComponentView.Default,
          RAConfig: this.view === ComponentView.Config,
          RACheckout: this.view === ComponentView.Checkout,
        }}
      >
        {this.nodes.map((nodesObject, index) => {
          if (this.view === ComponentView.Config) {
            return <rtr-accordion-template-config nodesObject={nodesObject} nodeIndex={index} openedIndex={this.openedIndex} onOpenIndex={this.handleOpenIndex} />;
          }

          return <rtr-accordion-template nodesObject={nodesObject} nodeIndex={index} openedIndex={this.openedIndex} view={this.view} onOpenIndex={this.handleOpenIndex} />;
        })}
      </Host>
    );
  }
}
